import React, { memo, useRef } from "react";
import { Stack, Typography, Chip, Icon } from "investira.react.components";
/**
 * Renderiza o componente SearchIndicadoresItem.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {*} props.indicador - Propriedade `indicador` do componente.
 * @param {*} props.onClick - Propriedade `onClick` do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const SearchIndicadoresItem = memo(props => {
  const {
    indicador,
    onClick
  } = props;
  const INDICADORES_TIPO = useRef({
    M: {
      label: "Moeda",
      id: "M",
      icon: "coin"
    },
    C: {
      label: "Correção Monetária",
      id: "C",
      icon: "coins"
    },
    I: {
      label: "Índice de Mercado",
      id: "I",
      icon: "chart_line"
    },
    J: {
      label: "Juros",
      id: "J",
      icon: "percent"
    },
    T: {
      label: "Metal",
      id: "T",
      icon: "metal"
    }
  });
  const xIndicadoresTipo = INDICADORES_TIPO.current;
  return <Stack id={indicador.indicador_id} key={indicador.indicador_id} direction="row" flexGrow={1} spacing={3} alignItems="flex-start" component="li" onClick={onClick} sx={{
    px: 2,
    py: 2,
    cursor: "pointer",
    "&:hover": {
      color: "gray",
      backgroundColor: "background.main"
    },
    borderBottom: "1px solid",
    borderBottomColor: "background.main"
  }}>
      {indicador?.indicador_tipo_id && xIndicadoresTipo[indicador.indicador_tipo_id] && <Stack backgroundColor="primary.main" width="36px" height="36px" justifyContent="center" alignItems="center" borderRadius="8px">
            <Icon iconName={xIndicadoresTipo[indicador.indicador_tipo_id].icon} color="secondary" size={18} />
          </Stack>}
      <Stack flexGrow={1}>
        <Typography variant="body2" color="textPrimary" sx={{
        fontWeight: 600
      }}>
          {indicador.indicador_id}
        </Typography>
        <Stack direction="row" spacing={{
        xs: 0,
        sm: 1
      }} mb={1}>
          <Typography variant="caption" color="textPrimary" sx={{
          display: {
            xs: "none",
            sm: "inline-block"
          }
        }}>
            {indicador.indicador}
          </Typography>
        </Stack>
      </Stack>

      {indicador?.indicador_tipo_id && xIndicadoresTipo[indicador.indicador_tipo_id] && <Stack>
            <Stack justifyContent="end">
              <Chip label={xIndicadoresTipo[indicador.indicador_tipo_id].label} size="small" color="primary" />
            </Stack>
          </Stack>}
    </Stack>;
});
export default SearchIndicadoresItem;
